import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { endPoints } from '../../Config';
import { handleGetRequest } from '../../service/GetTemplate';
import { handlePutRequest } from '../../service/PutTemplate';

export const canManageWarehouse = user => ['admin', 'superAdmin', 'support', 'technician'].includes(user?.role?.uid) && user?.isActive !== false && user?.isDeleted !== true;
export default function MachineWarehouseDialog({ machineId, onClose, onSaved }) {
    const dispatch = useDispatch();
    const [machine, setMachine] = useState(null);
    const [action, setAction] = useState('enter');
    const [place, setPlace] = useState('');
    const [notes, setNotes] = useState('');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    useEffect(() => {
        let live = true;
        setMachine(null);
        handleGetRequest(endPoints.machineWarehouse(machineId), true, false, dispatch).then(response => {
            if (!live) return;
            if (!response?.data?._id) { setError('No se pudo cargar el registro de bodega.'); return; }
            setMachine(response.data);
            setPlace(response.data.warehouseName || '');
        });
        return () => { live = false; };
    }, [machineId, dispatch]);
    const save = async () => {
        if (!machine || saving || !place.trim()) return;
        setSaving(true); setError('');
        try {
            const response = await dispatch(handlePutRequest({ action, place: place.trim(), notes: notes.trim(), expectedUpdatedAt: machine.updatedAt }, endPoints.machineWarehouse(machineId), false, false));
            if (response?.status === 200) onSaved();
            else setError(response?.data?.message || 'No se pudo guardar. Vuelve a abrir el registro para actualizar los datos.');
        } finally { setSaving(false); }
    };
    return <Dialog visible modal header="Registro de bodega" style={{ width: '42rem', maxWidth: '95vw' }} onHide={() => { if (!saving) onClose(); }}
        footer={<><Button label="Cancelar" disabled={saving} onClick={onClose} className="p-button-text" /><Button label={action === 'enter' ? 'Registrar ingreso a bodega' : 'Confirmar salida de bodega'} disabled={!machine || saving || !place.trim()} loading={saving} onClick={save} /></>}>
        {error && <p role="alert">{error}</p>}
        {machine && <>
            <p><strong>{machine.serialNumber || machine.deviceId || machine.uuid}</strong> · {machine.inStockInventory ? `En bodega${machine.warehouseName ? ': ' + machine.warehouseName : ''}` : 'Fuera de inventario'}</p>
            {!!machine.pendingInstallations?.length && <p>Instalación pendiente. {machine.inStockInventory ? 'En inventario · Reservada para instalación.' : 'Fuera de bodega.'}</p>}
            <p>Registra la ubicación física. La instalación y su lista de verificación seguirán pendientes hasta su cierre habitual.</p>
            <div className="flex gap-2 mb-3"><Button label="Ingreso" onClick={() => { setAction('enter'); setPlace(machine.warehouseName || ''); }} /><Button label="Salida" disabled={!machine.inStockInventory} onClick={() => { setAction('exit'); setPlace(''); }} /></div>
            {action === 'enter' && <p>Al confirmar el ingreso se desvinculará la ubicación de ruta actual. Quedará guardada en el historial.</p>}
            <label htmlFor="warehouse-place" className="block mb-2">{action === 'enter' ? 'Bodega' : 'Destino de salida'}</label>
            <InputText id="warehouse-place" value={place} maxLength={200} onChange={e => setPlace(e.target.value)} className="w-full mb-3" />
            <label htmlFor="warehouse-notes" className="block mb-2">Observaciones (opcional)</label>
            <InputTextarea id="warehouse-notes" value={notes} maxLength={2000} onChange={e => setNotes(e.target.value)} className="w-full mb-3" />
            <h4>Últimos registros</h4>
            {machine.warehouseAudit?.length ? machine.warehouseAudit.map((event, i) => <p key={event._id || i}>{event.action === 'enter' ? 'Ingreso' : 'Salida'} · {event.place} · {event.actorName} · {new Date(event.at).toLocaleString('es-PA', { timeZone: 'America/Panama' })}{event.notes ? ` · ${event.notes}` : ''}</p>) : <p>Sin registros de bodega.</p>}
        </>}
    </Dialog>;
}
